<h2 mat-dialog-title>
  {{'Filter'}}
  <span class="float-right">
    <i class="fa fa-times" (click)="close()"></i></span>
</h2>

<mat-dialog-content>
  <div class="text-center mb-1">
    <button class="btn btn-sm action-btn" (click)="newTemplate()"> New </button>
    <button class="btn btn-sm action-btn ml-1" (click)="customFilter()"> Custom </button>
  </div>


  <div class="form-group">
    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="search"
      (ngModelChange)="searchTemplate($event)">
    <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
  </div>


  <div class="action-template-list">
    <ng-container *ngIf="filtered_template_list && filtered_template_list.length">
      <div class="card mb-1" *ngFor="let item of filtered_template_list;let i = index">
        <div class="card-body padding">
          <h6 class="card-title mb-0 pointer">
            <span (click)="selectNewFilter(item)" class="link">{{ item.filter_template_title }}</span>
            <i class="fa fa-pencil pointer float-right" (click)="editTemplate(item)"></i>
          </h6>
          <!-- <small class="card-text">Created by {{ item.CreatedInfo }} on {{ item.createdDate }} <br>
          Updated by {{ item.UpdatedInfo }} on {{ item.updatedDate }}</small> -->
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!(filtered_template_list && filtered_template_list.length)">
      <div class="text-center no-records-found">
        No data found!
      </div>
    </ng-container>


  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions>

</mat-dialog-actions> -->
